import { get } from 'lodash';

const root = (state) => get(state, 'sidebar');

export const getMenuOpened = (state) => get(root(state), 'menuOpened', false);
export const getOpenedFromMap = (state) =>
  get(root(state), 'openedFromMap', false);
